'use strict';

var Recaptcha = require('../util/recaptcha');

const SUBMIT_EVENT_NAMESPACE = 'submit.footerSubscribe';
const SUBMIT_LOCK_KEY = 'isFooterSubscribeSubmitting';

/**
 * Toggle submit lock + button state on the newsletter form.
 * @param {jQuery} $form - subscription form
 * @param {boolean} isSubmitting - lock state
 */
const setSubmitState = ($form, isSubmitting) => {
    $form.data(SUBMIT_LOCK_KEY, isSubmitting);
    $form.find('.js-email-subscribe').prop('disabled', isSubmitting);
};

const showTechnicalErrorModal = ($modal, message) => {
    var $title = $modal.find('.js-optin-title');
    var $description = $modal.find('.js-optin-description');

    $modal.find('.js-optin-icon').addClass('d-none');
    $modal.find('.js-optin-subtitle').addClass('d-none');
    $title.text($title.data('error'));
    $description.text(message || $description.data('error'));
    $modal.modal('show');
};

const handleFooterSubscribe = () => {
    $('body').off(SUBMIT_EVENT_NAMESPACE, '.js-email-subscribe-form').on(SUBMIT_EVENT_NAMESPACE, '.js-email-subscribe-form', function (e) {
        e.preventDefault();

        let $form = $(this);

        // Guard against rapid multi-clicks and duplicate event bindings.
        if ($form.data(SUBMIT_LOCK_KEY)) {
            return false;
        }

        setSubmitState($form, true);

        let $errorMsg = $form.find('.invalid-feedback');
        $errorMsg.text('');
        $errorMsg.removeClass('d-block');

        const url = $form.find('.js-email-subscribe').data('href'); // EmailSubscribe-Show
        const $mail = $form.find('input[name="hpEmailSignUp"]');
        const $honeypot = $form.find('input[name="website"]');

        var $modal = $('#optinModal');

        Recaptcha.generateToken('account_register').then(function (token) {
            var data = {
                hpEmailSignUp: $mail.val(),
                website: $honeypot.val(),
                'g-recaptcha-response': token
            };
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                data: data,
                success: function (response) {
                    if (response.error) {
                        if (response.technical) {
                            showTechnicalErrorModal($modal, response.msg);
                        } else {
                            // error form input
                            $errorMsg.text(response.msg);
                            $errorMsg.addClass('d-block');
                        }
                    } else {
                        // reset modal design for possible second try after failed attempt
                        $modal.find('.js-optin-icon').removeClass('d-none');
                        $modal.find('.js-optin-subtitle').removeClass('d-none');
                        var $descSuccess = $modal.find('.js-optin-description');
                        $descSuccess.text($descSuccess.data('succes'));
                        var $titleSuccess = $modal.find('.js-optin-title');
                        $titleSuccess.text($titleSuccess.data('succes'));

                        if (response.doubleOptin) {
                            $modal.find('.js-optin-description').text(response.msg);
                        }

                        $modal.modal('show');
                    }
                },
                error: function (errorResponse) {
                    var responseMessage = errorResponse && errorResponse.responseJSON && errorResponse.responseJSON.msg;
                    showTechnicalErrorModal($modal, responseMessage);
                },
                complete: function () {
                    $.spinner().stop();
                    setSubmitState($form, false);
                }
            });
        }).catch(function () {
            showTechnicalErrorModal($modal);
            setSubmitState($form, false);
        });

        return false;
    });
};

const init = () => {
    handleFooterSubscribe();
};

module.exports = {
    init: init
};
